<template>
  <!-- 来源管理 -->
  <div class="layout">
    <div class="menu">
      <Menu topIndex="dataBase"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="dataBase" leftIndex="sourceManage"></LeftSideBar>
    </div>
    <div id="deptContentBox" class="base-content">
      <!-- 上方button -->
      <div>
        <el-button
          type="text"
          size="small"
          icon="el-icon-plus"
          @click="firstCreate()"
          >新建</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          @click="preCheck('toEdit')"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-close"
          @click="preCheck('toDelete')"
          >删除</el-button
        >
      </div>
      <!-- 搜索部分 -->
      <div id="searchBox">
        <el-form ref="sourceForm" :model="sourceForm" label-width="80px">
          <el-form-item label="来源名称">
            <el-input
              v-model="sourceForm.name"
              placeholder="请输入来源名称"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="0px">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-search"
              @click="
                currentPage = 1;
                onSearch();
              "
              >查询</el-button
            >
            <el-button type="primary" size="mini" icon="el-icon-delete"
              >重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 主内容列表 -->
      <el-table
        :data="sourceTableData"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
        @selection-change="handleTableSelectionChange"
      >
        <el-table-column
          type="selection"
          min-width="55"
          align="center"
        ></el-table-column>
        <el-table-column type="index" min-width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          show-overflow-tooltip
          min-width="80"
          label="来源名称"
          align="center"
        ></el-table-column>
        <el-table-column prop="id" min-width="80" label="来源ID" align="center">
        </el-table-column>
        <el-table-column
          prop="itemInfo.name"
          show-overflow-tooltip
          label="数据结构"
          min-width="70px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="数据类型"
          min-width="70px"
          align="center"
        >
          <template slot-scope="scope">
            <p v-if="scope.row.type == 10">百科条目</p>
            <p v-if="scope.row.type == 20">辞典工具书</p>
            <p v-if="scope.row.type == 30">专项数据</p>
            <p v-if="scope.row.type == 40">图书</p>
            <p v-if="scope.row.type == 50">图片</p>
            <p v-if="scope.row.type == 60">音频</p>
            <p v-if="scope.row.type == 70">视频</p>
            <p v-if="scope.row.type == 80">图片集</p>
            <p v-if="scope.row.type == 90">音频集</p>
            <p v-if="scope.row.type == 100">视频集</p>
            <p v-if="scope.row.type == 110">3D动画</p>
            <p v-if="scope.row.type == 120">论文</p>
            <p v-if="scope.row.type == 130">文章</p>
            <p v-if="scope.row.type == 140">问答对</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          show-overflow-tooltip
          label="备注"
          align="center"
        >
        </el-table-column>
      </el-table>
      <!-- 主列表分页 -->
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新建来源弹窗 -->
    <el-dialog title="新建来源" :visible.sync="createDialog" width="600px">
      <el-form
        ref="addSourceForm"
        :rules="addSourceRules"
        :model="addSourceForm"
        label-width="100px"
      >
        <el-form-item label="来源名称：" prop="name">
          <el-input
            v-model="addSourceForm.name"
            placeholder="请输入来源名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="数据结构：" prop="itemId">
          <el-select v-model="addSourceForm.itemId" clearable>
            <el-option
              v-for="item in dictionaryList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据类型：" prop="type">
          <el-select v-model="addSourceForm.type" clearable>
            <el-option
              v-for="item in typeList"
              :key="item.code"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            v-model="addSourceForm.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createSource('addSourceForm')"
          >确 定
        </el-button>
        <el-button @click="createDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑来源弹窗 -->
    <el-dialog title="编辑来源" :visible.sync="editDialog" width="600px">
      <el-form
        ref="editSourceForm"
        :rules="editSourceRules"
        :model="editSourceForm"
      >
        <el-form-item label="来源名称" label-width="80px" prop="name">
          <el-input
            v-model="editSourceForm.name"
            placeholder="请输入来源名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="数据结构" label-width="80px" prop="itemId">
          <el-select v-model="editSourceForm.itemId" clearable>
            <el-option
              v-for="item in dictionaryList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" label-width="80px">
          <el-input
            v-model="editSourceForm.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateSource('editSourceForm')"
          >确 定
        </el-button>
        <el-button @click="editDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 删除来源弹窗 -->
    <el-dialog title="删除来源" :visible.sync="deleteDialog" width="30%" center>
      <div>确定删除该来源？</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onDelete">确 定</el-button>
        <el-button @click="deleteDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data() {
    return {
      addSourceForm: {
        name: "",
        itemId: "",
        remark: "",
      },
      editSourceForm: {
        name: "",
        itemId: "",
        remark: "",
      },
      sourceForm: {
        id: "",
        name: "",
      },
      typeList: [
        {
          label: "百科条目",
          value: 10,
        },
        {
          label: "辞典工具书",
          value: 20,
        },
        {
          label: "专项数据",
          value: 30,
        },
        {
          label: "图书",
          value: 40,
        },
        {
          label: "图片",
          value: 50,
        },
        {
          label: "音频",
          value: 60,
        },
        {
          label: "视频",
          value: 70,
        },
        {
          label: "图片集",
          value: 80,
        },
        {
          label: "音频集",
          value: 90,
        },
        {
          label: "图书",
          value: 30,
        },
        {
          label: "视频集",
          value: 100,
        },
        {
          label: "3D动画",
          value: 110,
        },
        {
          label: "论文",
          value: 120,
        },
        {
          label: "文章",
          value: 130,
        },
        {
          label: "问答对",
          value: 140,
        },
      ],
      sourceTableData: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 50,
      dataText: "",
      optionData: [],
      dictionaryList: [],
      multipleSelectionTable: [],
      editDialog: false,
      deleteDialog: false,
      createDialog: false,
      addSourceRules: {
        name: [{ required: true, message: "请输入来源名称", trigger: "blur" }],
        itemId: [{ required: true, message: "请选择itemId", trigger: "blur" }],
        type: [{ required: true, message: "请选择数据类型", trigger: "blur" }],
      },
      editSourceRules: {
        name: [{ required: true, message: "请输入来源名称", trigger: "blur" }],
        itemId: [{ required: true, message: "请选择itemId", trigger: "blur" }],
        type: [{ required: true, message: "请选择数据类型", trigger: "blur" }],
      },
    };
  },
  components: {
    Menu,
    LeftSideBar,
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    this.searchParam();
  },
  methods: {
    // 搜索
    onSearch() {
      this.searchParam();
    },
    // 加载数据
    searchParam() {
      let that = this;
      let params = Object.assign({}, this.sourceForm);
      params.size = this.pageSize;
      params.page = this.currentPage;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/source/sourceInfo/list",
        data: params,
        contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            console.log(params);
            that.optionData = response.obj.list;
            if (response.obj && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.totalSize = response.obj.total;
            that.sourceTableData = response.obj.list;
            that.currentPage = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 显示新增弹框
    firstCreate() {
      this.createDialog = true;
      this.getdictionaryItem();
      this.addSourceForm = {
        name: "",
        itemId: "",
        remark: "",
      };
    },
    // 新增来源
    createSource(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //     if (this.addSourceForm.parentId) {
          //       delete this.addSourceForm.webUrl;
          //     }
          let that = this;
          //     that.noClick = true;
          $.ajax({
            url: "/zyk/c/source/sourceInfo/add",
            type: "POST",
            dataType: "json",
            data: this.addSourceForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "新增成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.createDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                  onClose: function () {
                    // that.noClick = false;
                  },
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 编辑
    editSource(row) {
      // if (this.pageAuth.s || this.isadmin) {
      //   this.searchTreeData();
      // }
      this.editSourceForm = {
        id: row[0].id,
        name: row[0].name,
        remark: row[0].remark,
        itemId: row[0].itemId,
      };
      this.getdictionaryItem();
      this.editDialog = true;
    },
    // 确认修改
    updateSource(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          // that.noClick = true;
          $.ajax({
            url: "/zyk/c/source/sourceInfo/update",
            type: "POST",
            dataType: "json",
            data: that.editSourceForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "修改成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.editDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                  onClose: function () {
                    // that.noClick = false;
                  },
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 编辑、删除前确认
    preCheck(current) {
      if (this.multipleSelectionTable.length == 0) {
        this.$message({
          message: "请选中具体的组织机构",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else if (current == "toEdit") {
        // 编辑确认
        if (this.multipleSelectionTable.length == 1) {
          this.editSource(this.multipleSelectionTable);
        } else {
          this.$message({
            message: "请勿选择多个进行编辑",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "toDelete") {
        this.deleteDialog = true;
      }
    },
    // 删除
    onDelete() {
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      console.log(ids);
      let that = this;
      // that.noClick = true;
      $.ajax({
        url: "/zyk/c/source/sourceInfo/remove",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { ids: ids.toString() },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          console.log(data);
          if (data.code == 200) {
            that.$message({
              message: "删除成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.searchParam();
            that.deleteDialog = false;
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
              onClose: function () {
                // that.noClick = false;
              },
            });
          }
        },
      });
    },
    // 加载数据结构
    getdictionaryItem() {
      let that = this;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/dictionary/getItemByCode",
        data: { code: "resourceConvert" },
        contentType: "application/json;charset=utf-8",
        success: function (response) {
          console.log(response.obj);
          if (response.code == 200) {
            if (response.obj && response.obj.length == 0) {
              that.dataText = "暂无数据";
            }
            that.dictionaryList = response.obj;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 选择表格某一行
    handleTableSelectionChange(val) {
      this.multipleSelectionTable = val;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchParam();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchParam();
    },
  },
};
</script>

<style>
</style>